module.exports = __webpack_public_path__ + "01_face.0fe0f38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/01_face.png
// module id = YYto
// module chunks = 0